"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _UIButton = _interopRequireDefault(require("./UIButton"));

var _UILoadingSpinner = _interopRequireDefault(require("../loading/UILoadingSpinner"));

var _Functions = require("../core/Functions");

var _ButtonConstants = require("../button/ButtonConstants");

var UILoadingButton =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UILoadingButton, _React$Component);

  function UILoadingButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UILoadingButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UILoadingButton).call(this, props));

    _this.UNSAFE_componentWillReceiveProps = function (nextProps) {
      var wasLoading = _this.props.loading;
      var failed = nextProps.failed,
          loading = nextProps.loading,
          resultIcon = nextProps.resultIcon;
      var hasResult = resultIcon != null && !failed;
      var shouldDisplayResult = hasResult && wasLoading && !loading;

      if (loading !== wasLoading) {
        _this.setState({
          isLoading: loading,
          displayResult: shouldDisplayResult
        });
      }
    };

    _this.UNSAFE_componentWillUpdate = function (nextProps, nextState) {
      var duration = nextProps.duration;
      var wasLoading = _this.state.isLoading;
      var isLoading = nextState.isLoading;
      var startedLoading = !wasLoading && isLoading;

      if (duration && startedLoading) {
        clearTimeout(_this.loadingTimeout);
        _this.loadingTimeout = setTimeout(_this.handleLoadingFinish, duration);
      }
    };

    _this.handleLoadingFinish = function () {
      var _this$props = _this.props,
          failed = _this$props.failed,
          resultIcon = _this$props.resultIcon;
      var hasResult = resultIcon != null && !failed;

      _this.setState({
        isLoading: false,
        displayResult: hasResult
      });

      if (!hasResult) {
        _this.setDisplayResult();
      }
    };

    _this.setDisplayResult = function () {
      var _this$props2 = _this.props,
          onLoadingFinish = _this$props2.onLoadingFinish,
          keepResultAfterFinish = _this$props2.keepResultAfterFinish;

      _this.setState({
        displayResult: keepResultAfterFinish
      });

      onLoadingFinish();
    };

    _this.handleClick = function (evt) {
      var _this$props3 = _this.props,
          duration = _this$props3.duration,
          onClick = _this$props3.onClick,
          preventClicksOnLoading = _this$props3.preventClicksOnLoading;
      var _this$state = _this.state,
          displayResult = _this$state.displayResult,
          isLoading = _this$state.isLoading;

      if (preventClicksOnLoading && (isLoading || displayResult)) {
        evt.preventDefault();
        return;
      }

      (0, _Functions.callIfPossible)(onClick, evt);

      if (evt.defaultPrevented) {
        return;
      }

      if (!isLoading && duration) {
        _this.setState({
          isLoading: true
        });
      }
    };

    var _loading = props.loading;
    _this.state = {
      displayResult: false,
      isLoading: _loading || false
    };
    return _this;
  }

  (0, _createClass2.default)(UILoadingButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var duration = this.props.duration;
      var isLoading = this.state.isLoading;

      if (duration && isLoading) {
        this.loadingTimeout = setTimeout(this.handleLoadingFinish, duration);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.loadingTimeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          className = _this$props4.className,
          disabled = _this$props4.disabled,
          __duration = _this$props4.duration,
          failed = _this$props4.failed,
          __loading = _this$props4.loading,
          __onClick = _this$props4.onClick,
          __onLoadingFinish = _this$props4.onLoadingFinish,
          __preventClicksOnLoading = _this$props4.preventClicksOnLoading,
          __keepResultAfterFinish = _this$props4.keepResultAfterFinish,
          resultIcon = _this$props4.resultIcon,
          size = _this$props4.size,
          spinnerProps = _this$props4.spinnerProps,
          truncateTooltip = _this$props4.truncateTooltip,
          use = _this$props4.use,
          rest = (0, _objectWithoutProperties2.default)(_this$props4, ["children", "className", "disabled", "duration", "failed", "loading", "onClick", "onLoadingFinish", "preventClicksOnLoading", "keepResultAfterFinish", "resultIcon", "size", "spinnerProps", "truncateTooltip", "use"]);
      var _this$state2 = this.state,
          isLoading = _this$state2.isLoading,
          displayResult = _this$state2.displayResult;
      var disabledUnlessLoading = disabled && !isLoading && !displayResult;
      return _react.default.createElement(_UIButton.default, (0, _extends2.default)({}, rest, {
        size: size,
        use: use,
        "data-loading": isLoading,
        disabled: disabledUnlessLoading,
        className: (0, _classnames.default)('private-loading-button', className, _ButtonConstants.USE_CLASSES[use], {
          'loading private-loading-button--loading': isLoading || displayResult
        }),
        onClick: this.handleClick,
        truncateTooltip: truncateTooltip || children
      }), _react.default.createElement("span", {
        className: "private-loading-button__content private-button--internal-spacing"
      }, children), _react.default.createElement(_UILoadingSpinner.default, (0, _extends2.default)({}, spinnerProps, {
        className: "private-loading-button__spinner",
        "data-loading": null,
        failed: failed,
        use: use,
        size: size,
        resultIcon: resultIcon,
        showResult: displayResult,
        onResultDisplayFinish: this.setDisplayResult
      })));
    }
  }]);
  return UILoadingButton;
}(_react.default.Component);

exports.default = UILoadingButton;
UILoadingButton.propTypes = (0, _extends2.default)({}, _UIButton.default.propTypes, {
  failed: _UILoadingSpinner.default.propTypes.failed,
  size: _UILoadingSpinner.default.propTypes.size,
  use: _UILoadingSpinner.default.propTypes.use,
  duration: _propTypes.default.number,
  loading: _propTypes.default.bool,
  resultIcon: _UILoadingSpinner.default.propTypes.resultIcon,
  onLoadingFinish: _propTypes.default.func,
  spinnerProps: _propTypes.default.object,
  preventClicksOnLoading: _propTypes.default.bool,
  keepResultAfterFinish: _propTypes.default.bool
});
UILoadingButton.defaultProps = (0, _extends2.default)({}, _UIButton.default.defaultProps, {
  failed: _UILoadingSpinner.default.defaultProps.failed,
  onLoadingFinish: _emptyFunction.default,
  preventClicksOnLoading: true,
  keepResultAfterFinish: false,
  resultIcon: _UILoadingSpinner.default.defaultProps.resultIcon,
  size: 'medium',
  use: 'secondary'
});
UILoadingButton.displayName = 'UILoadingButton';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/button/UILoadingButton.js
// module id = 323
// module chunks = 5 6